import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

const Save = ({ attributes }) => {
    const { numCols } = attributes;

    // console.log('Num of columns from save:', numCols);

    return (
        <div {...useBlockProps.save()}>
            <div className={`row row-cols-1 row-cols-sm-2 row-cols-md-${numCols} g-3`}>
                <InnerBlocks.Content />
            </div>
        </div>
    );
};

export default Save;
